import { render } from "./01_HeroSlider.vue?vue&type=template&id=06c0d124&scoped=true"
import script from "./01_HeroSlider.vue?vue&type=script&lang=js"
export * from "./01_HeroSlider.vue?vue&type=script&lang=js"

import "./01_HeroSlider.vue?vue&type=style&index=0&id=06c0d124&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c0d124"]])

export default __exports__